import React from "react";
import FitoutBannersTable from "../Components/Pages/FitoutBanners/FitoutBannersTable";

function FitoutBanners() {
  return (
    <div>
      <div className="p-10">
      <FitoutBannersTable />
      </div>
    </div>
  );
}

export default FitoutBanners;
